import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-37c43327"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("template", null, null, -1));

const _hoisted_2 = ["onClick", "innerHTML"];
const _hoisted_3 = ["onClick", "innerHTML"];
import WidgetItem from '@/components/WidgetItem/index.vue';
import { getTextWidth } from '@/utils';
import { safeHtml } from '@/utils/sanitize';
import { isFunction } from 'lodash';
import { useAttrs } from 'vue';
const __default__ = {
  name: 'Column',
  inheritAttrs: false
};
export default /*#__PURE__*/_defineComponent({ ...__default__,
  props: {
    columnList: {
      type: Array,
      default: []
    },
    formatData: {
      type: Function
    }
  },

  setup(__props) {
    const props = __props;
    const attrs = useAttrs();

    const controlColumn = config => {
      const {
        controller
      } = config;
      return controller ? controller(config) : true;
    };

    const handleClick = (scope, item) => {
      const {
        click
      } = item;
      click && click(scope.column.property, scope.row, scope);
    }; // 给单元格添加类名，仅限全局类名


    const getItemClass = (scope, config) => {
      const {
        cellClass,
        click
      } = config;
      return [{
        'span--click': click
      }, isFunction(cellClass) ? cellClass(scope.row, config) : cellClass];
    };

    const init = (scope, config) => {
      const value = scope.row[scope.column.property];
      const label = scope.column.property; // console.log(scope, label, value);

      let result;

      if (config.formatter) {
        result = config.formatter(value) || config.formatter(value) === 0 ? config.formatter(value) : '--';
      } else {
        result = value || value === 0 ? value : '--';
      } // 该返回值用于 v-html 渲染，统一做 XSS 净化


      return safeHtml(result);
    }; // 内容超出时显示提示


    const tipDisabled = ref(false);

    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(target.innerText);
      tipDisabled.value = target.offsetWidth < width ? false : true;
    };

    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_Column = _resolveComponent("Column", true);

      const _component_RowWarpPopper = _resolveComponent("RowWarpPopper");

      return _openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columnList, (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: index
        }, [item.type ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [controlColumn(item) ? (_openBlock(), _createBlock(_component_el_table_column, _normalizeProps(_mergeProps({
          key: 0
        }, item)), null, 16)) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [controlColumn(item) && !item.isSelect ? (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
          key: 0,
          "show-overflow-tooltip": item.showOverflowTooltip ?? !item.showTooltip ?? true
        }, item), {
          header: _withCtx(() => [_createElementVNode("span", {
            class: _normalizeClass({
              'field-required-after': item.required
            })
          }, [_renderSlot(_ctx.$slots, "title", _normalizeProps(_guardReactiveProps({
            label: item.label,
            nodeDate: item
          })), () => [_createTextVNode(_toDisplayString(_ctx.$t(item.label)), 1)])], 2)]),
          default: _withCtx(scope => [item.cellSlot ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [item.slotName ? _renderSlot(_ctx.$slots, item.slotName, _normalizeProps(_mergeProps({
            key: 0
          }, scope))) : _renderSlot(_ctx.$slots, "cellSlot", _normalizeProps(_mergeProps({
            key: 1
          }, scope)))], 64)) : item.headerChildren ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_hoisted_1, _createVNode(_component_Column, {
            "column-list": item.headerChildren,
            "format-data": __props.formatData
          }, null, 8, ["column-list", "format-data"])], 64)) : item.showTooltip ? (_openBlock(), _createBlock(_component_RowWarpPopper, {
            key: 2,
            disabled: tipDisabled.value,
            sourceData: init(scope, item)
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              onMouseover: showTextTip,
              class: _normalizeClass({
                'span--click': item.click,
                'cms-text-overflow': true
              }),
              onClick: $event => handleClick(scope, item),
              innerHTML: init(scope, item)
            }, null, 42, _hoisted_2)]),
            _: 2
          }, 1032, ["disabled", "sourceData"])) : item.type ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 3
          }, [], 64)) : item.widgetType ? (_openBlock(), _createBlock(WidgetItem, {
            key: 4,
            "widget-config": item,
            "widget-data": scope.row,
            "scope-data": scope
          }, null, 8, ["widget-config", "widget-data", "scope-data"])) : _renderSlot(_ctx.$slots, "cell", _normalizeProps(_mergeProps({
            key: 5
          }, scope)), () => [_createElementVNode("span", {
            class: _normalizeClass(getItemClass(scope, item)),
            onClick: $event => handleClick(scope, item),
            innerHTML: init(scope, item)
          }, null, 10, _hoisted_3)])]),
          _: 2
        }, 1040, ["show-overflow-tooltip"])) : _createCommentVNode("", true)], 64))], 64);
      }), 128);
    };
  }

});